import { render, staticRenderFns } from "./drawerH5.vue?vue&type=template&id=2f143c9c&scoped=true"
import script from "./drawerH5.vue?vue&type=script&lang=js"
export * from "./drawerH5.vue?vue&type=script&lang=js"
import style0 from "./drawerH5.vue?vue&type=style&index=0&id=2f143c9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f143c9c",
  null
  
)

export default component.exports